import Info from './Info';
import App from './App';


export  { Info, App };





// WEBPACK FOOTER //
// ./src/views/index.js